import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';

import * as ProformaActions from '@core/actions/proforma.actions';

import { EnrichEditForm } from "@app/modules/supplier-portal/components/enrich-edit-form/enrich-edit-form.component";
import { FollowIdComponent } from "@app/modules/supplier-portal/components/followId-confirmation/followId-confirmation.component";

@Component({
    selector: 'app-enrich-table',
    templateUrl: './enrich-table.component.html',
    styleUrls: ['./enrich-table.component.css']
  })

  export class EnrichTable implements OnInit {
    constructor(
      private ngProgress: NgProgress,
      private store: Store<any>,
      private modal: NgbModal,
    ){}

    @ViewChild('fileInput')
    inputEl: ElementRef;

    progressRef: NgProgressRef

    @Input()
    enrichData;

    @Input()
    me;

    @Input()
    followId: any;

    @Output()
    downloadEnrich = new EventEmitter();

    @Output()
    uploadMassive = new EventEmitter();

    @Output()
    changeFilterData = new EventEmitter();

    @Output()
    changeFollowIds = new EventEmitter()

    isShow = false;
    currentN2 = "";
    currentIndex = null;
    currentN2Products = [];
    _modalRef;

    Supplier = [];
    FollowIds = [];
    N2 = []
    currentSupplierSelected = "";
    currentFollowSelected = "";
    currentN2Selected = "";
    currentEnrichData = [];
    _alive = true;
    _modalObservation = null;

    currentPage = 1;
    pages: number = 1;

    get show(){
      return this.me && (this.me.role === 'product-manager' || this.me.role === 'merchant')  
    }

    ngOnInit() {
      this.progressRef = this.ngProgress.ref();
    }

    filterEnrichData(){
      let aux = this.enrichData
      return aux
    }

    filterData(type){
      this.enrichData.map((e) => {
        if(this.Supplier.length === 0 || 
          !this.Supplier.map((s) => s.id).includes(e.id)){
          this.Supplier.push({
            id: e.id,
            name: e.name
          })
        }
        if(this.FollowIds.length === 0 || 
          !this.FollowIds.includes(e.FollowId)){
          this.FollowIds.push(e.FollowId)
        }
        if(this.N2.length === 0 || 
          !this.N2.map((n) => n.id).includes(e.n2Id)){
            this.N2.push({
              id: e.n2Id,
              name: e.n2Name
            })
          }
      })
      if(type === "supplier"){
        return this.Supplier
      }else if(type === "Follow"){
        return this.FollowIds
      }else{
        return this.N2
      }
    }

    download(ed){
      this.downloadEnrich.emit(`${ed.id}$-$${ed.FollowId}$-$${ed.n2Id}`)
    }

    changeFileInput(e, ed) {
      if (e.target.files) {
        const files = e.target.files;
  
        if (files && files[0]) {
          this.store.dispatch(new ProformaActions.GetUploadLink(files[0], 'massiveEnrich', ed))
        }
  
        e.target.value = null;
      }
    }

    editEnrich(p){
      if(p && p.code){
        this._modalRef = this.modal.open(EnrichEditForm, {
          backdrop : 'static',
          keyboard : false
        });
        this._modalRef.componentInstance.product = p
        this._modalRef.result.then(
          result => {
            // do nothing
          },
          res => {
            if(res){
              this.store.dispatch(new ProformaActions.UpsertEnrichProducts(res, this.me.role === "supplier" ? this.me.ProviderId : null))
            }
          }
        )
      }
    }

    changeEnrichStatus(p){
      this.store.dispatch(new ProformaActions.UpsertEnrichProducts({ enrichStatus: p.enrichStatus === 0 ? 1 : 0, productId: p.id }))
    }

    canEdit(status){
      return this.me.role !== 'product-manager' && status === 1 ? true : false
    }
    
    changeFilter(e, type){
      if(type === "supplier"){
        this.currentSupplierSelected = e.target.value
      }else if(type === "Follow"){
        this.currentFollowSelected = e.target.value
      }else{
        this.currentN2Selected = e.target.value
      }
      this.changeFilterData.emit({e, type})
    }

    changeFollowId(){
      this._modalObservation = this.modal.open(FollowIdComponent, {
        backdrop : 'static',
        keyboard : false
      });
      this._modalObservation.result.then(
        result => {
          // do nothing
        },
        res => {
          if(res){
            this.changeFollowIds.emit(res)
          }
        }
      )
      this._modalObservation = null
    }

  }